import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const OsSupport = () => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  return (
    <View locale={locale === 'ru' ? 'ru' : 'en'}>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.os-support.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.os-support.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 50%;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background: ${(p) => `image-set(
        url('/images/mainpage/os-support-bg-mob-${p.locale}.webp') type('image/webp'),
        url('/images/mainpage/os-support-bg-mob-${p.locale}.png') type('image/png')
      )
      50% 100% / calc(100% - 32px) auto no-repeat,
    #ffffff`};

  @media ${Points.tablet_landscape} {
    padding: 30px 33px 39.3% 30px;
    background: ${(p) => `image-set(
          url('/images/mainpage/os-support-bg-tab-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/os-support-bg-tab-${p.locale}.png') type('image/png')
        )
        50% 100% / calc(100% - 62px) auto no-repeat,
      #ffffff`};
  }

  @media ${Points.laptop_wide} {
    padding: 40px;
    background: ${(p) => `image-set(
          url('/images/mainpage/os-support-bg-lap-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/os-support-bg-lap-${p.locale}.png') type('image/png')
        )
        50% 100% / calc(100% - 80px) auto no-repeat,
      #ffffff`};
    border-radius: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }
`;
